module.exports = __webpack_public_path__ + "img/top5.202e5515.svg";